import * as React from "react";
const SvgFiRrBowlChopsticks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowl-chopsticks_svg__a)">
      <path
        fill="#062147"
        d="M3.002 6.007a1 1 0 0 1 1-1h19.001a1 1 0 1 1 0 2h-19a1 1 0 0 1-1-1m1-2h.053l18.937-1a1 1 0 0 0 .946-1.052 1.01 1.01 0 0 0-1.05-.946l-18.938 1a1 1 0 0 0 .051 1.998m19.194 7.591a4 4 0 0 1 .642 3.552c-.708 2.421-1.989 4.605-3.708 6.316-1.617 1.61-3.9 2.534-6.268 2.534H10.14c-2.366 0-4.65-.924-6.268-2.533-1.719-1.713-3-3.897-3.707-6.317a4 4 0 0 1 .642-3.552A3.96 3.96 0 0 1 4.003 10h15.995c1.27 0 2.435.582 3.196 1.598zm-1.6 1.2A1.98 1.98 0 0 0 20 12H4.005c-.634 0-1.216.291-1.596.798a2.02 2.02 0 0 0-.322 1.791c.604 2.067 1.74 4.007 3.2 5.461C6.53 21.29 8.3 22 10.141 22h3.722c1.841 0 3.611-.71 4.856-1.95 1.458-1.453 2.595-3.393 3.2-5.46a2.02 2.02 0 0 0-.324-1.792"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-chopsticks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlChopsticks;
